import { ErrorView } from "@/components/ui/ErrorView";
import { Button } from "@/components/ui/shadcn/button";
import { useNavigate, useSearchParams } from "react-router";

const defaultDescription =
  "We couldn't sign you in. Please try again. If the problem persists, please contact support at support@rentinit.ae";

function LoginError() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");

  const errorDescriptionMap = {
    access_denied:
      "Access denied. Only admin users can sign in to this portal.",
    invalid_request: "User cancelled the login",
    error:
      "Something went wrong during the login, please try again later or contact us at support@rentinit.ae",
    unknown_error:
      "Something went wrong during the login, please try again later or contact us at support@rentinit.ae",
  };

  return (
    <div className="flex flex-col items-center gap-4 max-w-md mx-auto pt-20">
      <ErrorView
        description={
          error
            ? (errorDescriptionMap[error as keyof typeof errorDescriptionMap] ??
              defaultDescription)
            : defaultDescription
        }
      />
      <Button onClick={() => navigate("/")} className="w-48">
        Go to home
      </Button>
    </div>
  );
}

export default LoginError;
